import callUsage from '../assets/Images/callUsage.svg';
import messagesUsage from '../assets/Images/messageUsage.svg';
import dataUsage from '../assets/Images/dataUsage.svg';

export const PACKAGE_KEYS = ['data', 'calls', 'sms'];

export const imagesByCode = Object.freeze({
  S: messagesUsage,
  M: callUsage,
  P: dataUsage
});
export const packageTypeByCode = Object.freeze({
  S: 'sms',
  M: 'calls',
  P: 'data'
});
export const collectiveUsageByCode = Object.freeze({
  S: 'SMS',
  M: 'שיחות',
  P: 'גלישה'
});

export const usedMetricsByCode = Object.freeze({
  S: ' הודעות',
  M: ' דקות',
  P: 'GB'
});

export const FamilyBundleStatus = Object.freeze({
  Success: 0,
  SubscriberNotFound: 1,
  BanDetailNotFound: 2,
  NoUsagesDataFoundForSubscriber2276: 3,
  GeneralError: 4
});
